import { createSHA256 } from 'hash-wasm'

const CHUNK_SIZE = 8 * 1024 * 1024

const toBase64 = bytes => {
  let binary = ''

  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i])
  }

  return window.btoa(binary)
}

const readChunk = blob => {
  if (typeof blob.arrayBuffer === 'function') return blob.arrayBuffer()

  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(blob)
  })
}

const fileChecksum = async file => {
  try {
    const hasher = await createSHA256()
    hasher.init()

    for (let offset = 0; offset < file.size; offset += CHUNK_SIZE) {
      const chunk = await readChunk(file.slice(offset, offset + CHUNK_SIZE))

      hasher.update(new Uint8Array(chunk))
    }

    return toBase64(hasher.digest('binary'))
  } catch (error) {
    return null
  }
}

export default fileChecksum
